<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
[frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name" #title>忘れず注文商品リスト出力</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <wj-accordion #accordion_listOutput [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true"
            (initialized)="initCollapsed(accordion_listOutput, false)">
            <wj-accordion-pane>
              <div class="accordion-pane">商品リスト出力</div>
              <div>
                <div class="column-list">
                  <label class="list-input-title">出力対象データ</label>
                  <div class="list-input-content" style="width: 733px;">
                    <select class="combo-box-required" #cmb_confirmData
                      [(ngModel)]="kymw7403Model.confirmDataId">
                      <ng-template ngFor let-item [ngForOf]="kymw7403Model.confirmList">
                        <option value="{{item.id}}">{{item.caption}}</option>
                      </ng-template>
                    </select>
                  </div>

                  <label class="list-input-title">出力対象企画回</label>
                  <div class="list-input-content" style="width: 8rem;">
                    <input type="text" class="text-label-required" plessInputTextSub
                      [restrict]="'[0-9]'" [halfOnly]="true" [maxlength]="8"
                      [(ngModel)]="kymw7403Model.catalogId">
                  </div>

                  <label class="list-input-title">8週先受注可能チェック</label>
                  <div class="list-input-content">
                    <app-checkbox-label label="対象から8週先まで受注可能な商品のみ対象とする"
                      #chk_aheadEightWeeks></app-checkbox-label>
                  </div>

                  <label class="list-input-title">承認待商品</label>
                  <div class="list-input-content">
                    <app-checkbox-label label="含む" #chk_includeUnapproval
                      ></app-checkbox-label>
                  </div>
                </div>

                <div class="layout_end">
                  <button class="btn-secondary" (click)="eventOutputRememberGoodsInfo_CLICKHandler()">出力</button>
                </div>              
              </div>
            </wj-accordion-pane>
          </wj-accordion>

          <wj-accordion #accordion_diffOutput [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true"
            (initialized)="initCollapsed(accordion_diffOutput, false)">
            <wj-accordion-pane>
              <div class="accordion-pane">差分リスト出力</div>
              <div>
                <div class="column-list">
                  <label class="list-input-title">出力対象データ</label>
                  <div class="list-input-content" style="width: 733px;">
                    <select class="combo-box-required"
                      [(ngModel)]="kymw7403Model.confirmDataDiff">
                      <ng-template ngFor let-item [ngForOf]="kymw7403Model.confirmList">
                        <option value="{{item.id}}">{{item.caption}}</option>
                      </ng-template>
                    </select>
                  </div>

                  <label class="list-input-title">出力対象企画回</label>
                  <div class="list-input-content" style="width: 8rem;">
                    <input type="text" class="text-label-required" plessInputTextSub
                      [restrict]="'[0-9]'" [halfOnly]="true" [maxlength]="8"
                      [(ngModel)]="kymw7403Model.catalogIdDiff">
                  </div>

                  <label class="list-input-title">比較対象データ</label>
                  <div class="list-input-content" style="width: 733px;">
                    <select class="combo-box-required"
                      [(ngModel)]="kymw7403Model.comparingData">
                      <ng-template ngFor let-item [ngForOf]="kymw7403Model.confirmList">
                        <option value="{{item.id}}">{{item.caption}}</option>
                      </ng-template>
                    </select>
                  </div>

                  <label class="list-input-title">比較対象企画回</label>
                  <div class="list-input-content" style="width: 8rem;">
                    <input type="text" class="text-label-required" plessInputTextSub
                      [restrict]="'[0-9]'" [halfOnly]="true" [maxlength]="8"
                      [(ngModel)]="kymw7403Model.comparingCatalogId">
                  </div>
                </div>
                <div class="layout_end">
                  <button class="btn-secondary" (click)="eventOutputRememberGoodsDiff_CLICKHandler()">出力</button>
                </div>
              </div>
            </wj-accordion-pane>
          </wj-accordion>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>